// components/util/AuthContext.jsx

import React, { createContext, useEffect, useState } from "react";
import { loginMember } from "../screens/apps_manage/api";
import { useUserStore } from "../../store/useUserStore";

export const AuthContext = createContext();


export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

   const setAvatar = useUserStore((state) => state.setAvatar);
  const setName = useUserStore((state) => state.setName);
  const setRole = useUserStore((state) => state.setRole);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      // You might want to verify the token with your backend here
      setUser({ logged: true });
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const res = await loginMember({email,password})

      // axios only goes to catch if status is not 2xx,
      // so no need to strictly check === 200
      const token = res.data?.token;

      if (!token) {
        return { success: false, error: "Token not received" };
      }

      localStorage.setItem("token", token);

      setUser({ logged: true, token });
       const data=res?.data;
         setAvatar(data.avatar);
         setName(data.name);
         setRole(data.role);

      return { success: true };
    } catch (error) {
      console.error("Login error:", error);

      // return {
      //   success: false,
      //   error: error.response?.data?.message || error.message || "Login failed",
      // };
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
